import GenericModal from "./GenericModal-container";

/**
 * Export the top level component GenericModal-view
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default GenericModal;
